import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    replace: 'Replace logo',
    maxSize:
      'File size exceeds the allowed limit ( {size} MB ). Please upload a smaller file.',
    onlyTypes: 'Only JPEG, PNG, and WebP formats are supported.',
  },
};
